import type { PredictionMarketDetailsResponse } from "@roman/shared/hooks/PredictionMarket/useGetPredictionMarketDetails";
import { type Choice, PredictionMarketType } from "@roman/shared/utils/predictionMarket/utils";

/**
 * predictionMarketDetailsからchoices, sortedChoices, marketTypeを抽出する
 */
export const extractChoicesFromDetails = (predictionMarketDetails: PredictionMarketDetailsResponse | undefined) => {
  const predictionMarketChoices = predictionMarketDetails?.predictionMarket.predictionMarketChoices ?? [];

  // PredictionMarketChoiceWithProbability を Choice 型に変換
  const choices: Choice[] = predictionMarketChoices.map((c) => ({
    id: c.id,
    name: c.name,
    latestProbability: c.probability,
    commentCount: c.commentCount,
  }));

  // 3つ以上の場合は確率でソート
  const sortedChoices =
    choices.length >= 3
      ? [...choices].sort((a, b) => (b.latestProbability ?? 0) - (a.latestProbability ?? 0))
      : choices;

  // マーケットタイプを判定
  const marketType =
    choices.length < 2
      ? PredictionMarketType.TwoChoice
      : choices.length === 2
        ? PredictionMarketType.TwoChoice
        : PredictionMarketType.MultipleChoice;

  return { choices, sortedChoices, marketType };
};
